import { render, staticRenderFns } from "./baseHospital.vue?vue&type=template&id=50adcec2&scoped=true&"
import script from "./baseHospital.vue?vue&type=script&lang=js&"
export * from "./baseHospital.vue?vue&type=script&lang=js&"
import style0 from "./baseHospital.vue?vue&type=style&index=0&id=50adcec2&prod&lang=scss&"
import style1 from "./baseHospital.vue?vue&type=style&index=1&id=50adcec2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50adcec2",
  null
  
)

export default component.exports